import utils from "../utils";
import Splide from "@splidejs/splide";

function init() {

	flexSlider();
	flexCarousel();
	flexTwoColumnsCarousel();
	productGalleryCarousel();
	
}

function flexSlider() {

	var flexSliders = document.querySelectorAll(".splide.flex-slider-full")

	if(flexSliders.length > 0){

		utils.forEach(flexSliders, function (index, elem) {

			var flexSlider = new Splide(elem, {
				perPage: 1,
				perMove: 1,
				autoplay: false,
				interval: 5000,
				rewind: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				resetProgress: true,
				arrows: true,
				speed: 2000,
				pagination: false,
				arrowPath: "m16.02,19.97L.92,35.05c-1.16,1.07-1.24,2.87-.17,4.03,1.07,1.16,2.87,1.24,4.03.17.06-.06.12-.12.18-.18l17.1-17.09c1.07-1.08,1.11-2.81.08-3.93L4.97.84c-1.11-1.12-2.92-1.12-4.03,0-1.12,1.11-1.12,2.92,0,4.03l15.08,15.1Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
			});

			flexSlider.mount();

		});
		
	}

}

function flexCarousel() {

	var flexCarousels = document.querySelectorAll(".flex-carousel .splide.carousel");

	if(flexCarousels.length > 0){

		utils.forEach(flexCarousels, function (index, elem) {

			var perPageValue,
				perMoveValue,
				perPageValueLg,
				perMoveValueLg,
				perPageValueMd,
				perMoveValueMd,
				perPageValueSm,
				perMoveValueSm,
				perPageValueXs,
				perMoveValueXs,
				autoplay,
				interval;

			if(
				elem.classList.contains('primary') ||
				elem.classList.contains('secondary') ||
				elem.classList.contains('tertiary') ||
				elem.classList.contains('quaternary')
				){
					perPageValue = 3;
					perMoveValue = 3;
					perPageValueLg = 3;
					perMoveValueLg = 3;
					perPageValueMd = 2;
					perMoveValueMd = 2;
					perPageValueSm = 1;
					perMoveValueSm = 1;
					perPageValueXs = 1;
					perMoveValueXs = 1;
				} else {
					perPageValue = 6;
					perMoveValue = 6;
					perPageValueLg = 5;
					perMoveValueLg = 5;
					perPageValueMd = 4;
					perMoveValueMd = 4;
					perPageValueSm = 3;
					perMoveValueSm = 3;
					perPageValueXs = 2;
					perMoveValueXs = 2;
				}

			if ( elem.getAttribute('data-autoplay') ) {
				autoplay = elem.getAttribute('data-autoplay');
			} else {
				autoplay = false;
			}

			if ( elem.getAttribute('data-interval') ) {
				interval = elem.getAttribute('data-interval');
			} else {
				interval = 0;
			}

			var flexCarousel = new Splide(elem, {
				type: 'slide',
				gap: '2rem',
				padding: { left: '0', right: '10rem' },
				perPage: perPageValue,
				perMove: perMoveValue,
				snap: true,
				trimSpace: true,
				autoplay: autoplay,
				interval: interval,
				rewind: true,
				pauseOnHover: true,
				pauseOnFocus: false,
				resetProgress: true,
				arrows: false,
				speed: 2000,
				pagination: true,
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
				breakpoints: {
					1200: {
						perPage: perPageValueLg,
						perMove: perMoveValueLg,
						padding: { left: '0', right: '9rem' },
					},
					950: {
						perPage: perPageValueMd,
						perMove: perMoveValueMd,
						padding: { left: '0', right: '8rem' },
					},
					768: {
						perPage: perPageValueSm,
						perMove: perMoveValueSm,
						padding: { left: '0', right: '7rem' },
					},
					500: {
						perPage: perPageValueXs,
						perMove: perMoveValueXs,
						padding: { left: '1rem', right: '6rem' },
					},
				},
			});

			flexCarousel.mount();

		});
		
	}

}

function flexTwoColumnsCarousel() {

	var flexTwoColumnsCarousels = document.querySelectorAll(".flex-two-columns .splide.carousel")

	if(flexTwoColumnsCarousels.length > 0){

		utils.forEach(flexTwoColumnsCarousels, function (index, elem) {

			var flexTwoColumnsCarousel = new Splide(elem, {
				type: 'loop',
				perPage: 1,
				perMove: 1,
				autoplay: true,
				pauseOnHover: true,
				speed: 1500,
				arrows: false,
				interval: 3500,
				pagination: true,
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
			});

			flexTwoColumnsCarousel.mount();

		});
		
	}

}

function productGalleryCarousel() {

	var productGalleryCarousel = document.getElementById("product-gallery-carousel");

	if(productGalleryCarousel){

		window.productGallery = new Splide(productGalleryCarousel, {
			perPage: 1,
			autoplay: false,
			pauseOnHover: false,
			speed: 500,
			omitEnd: true,
			updateOnMove: true,
			pagination: true,
			arrows: false,
            arrowPath: "M40,20C40,8.97,31.03,0,20,0S0,8.97,0,20s8.97,20,20,20,20-8.97,20-20Zm-37.67,0C2.33,10.25,10.25,2.33,20,2.33s17.67,7.93,17.67,17.67-7.93,17.67-17.67,17.67S2.33,29.75,2.33,20ZM30.93,20.75h0c.4-.4.4-1.09,0-1.49l-8.63-8.63c-.41-.41-1.08-.41-1.49,0-.2.2-.31.46-.31.74h0c0,.28.11.55.31.74l6.83,6.84H9.15c-.58,0-1.05.47-1.05,1.05s.47,1.05,1.05,1.05h18.5l-6.83,6.84c-.4.4-.4,1.09,0,1.49.2.2.46.31.74.31s.55-.11.74-.31l8.63-8.63Z",
			classes: {
				// Add classes for arrows.
				arrows: "smx-navigation",
				arrow: "smx-nav",
				prev: "prev carousel-prev",
				next: "next carousel-next",
				pagination: "smx-pagination",
				page: "smx-dot",
			},
		});
		
		// Verifico che serva il carosello essendoci almeno due immagini da visualizzare
		if(!productGalleryCarousel.classList.contains('not-mount')){
	
			// Monto il carosello principale
			window.productGallery.mount();
	
		}

	}

}

export default { init, productGalleryCarousel };